import * as React from "react";
import type { Property } from "csstype";

import { style, Icon } from "./Symbolicons";

const GooglePlayColored = (
  props: Icon & { background?: Property.Fill },
): React.ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style(props.size, props.height) }}
  >
    <rect
      x={0.25}
      y={0.25}
      width={103.5}
      height={31.5}
      rx={3.75}
      fill={props.background || "#1F1F1F"}
    />
    <path
      d="M37.043 8.49a2.013 2.013 0 0 1-.548 1.475 2.113 2.113 0 0 1-1.61.648 2.186 2.186 0 0 1-1.616-.663 2.363 2.363 0 0 1 0-3.287 2.299 2.299 0 0 1 2.516-.479c.264.11.5.278.688.494l-.388.39a1.458 1.458 0 0 0-1.2-.53 1.758 1.758 0 0 0-1.682 1.307 1.774 1.774 0 0 0 .8 1.983 1.746 1.746 0 0 0 2.111-.247 1.42 1.42 0 0 0 .366-.899h-1.594v-.53h2.128c.017.112.027.225.03.339ZM40.394 6.648h-1.975v1.4h1.8v.531h-1.8v1.4h1.975v.546h-2.546V6.103h2.546v.545ZM42.793 10.524h-.563V6.649H41v-.545h3.051v.545h-1.258v3.877ZM46.202 10.524V6.103h.563v4.421h-.563ZM49.267 10.524h-.564V6.649h-1.229v-.545h3.014v.545h-1.221v3.877Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.592 10.622c.604 0 1.182-.242 1.61-.672a2.22 2.22 0 0 0 .643-1.636c.013-.61-.219-1.2-.644-1.636a2.186 2.186 0 0 0-1.61-.67 2.135 2.135 0 0 0-1.608.67 2.4 2.4 0 0 0 0 3.272c.426.43 1.005.672 1.609.672Zm0-.538c-.448 0-.878-.181-1.192-.503a1.882 1.882 0 0 1 0-2.535 1.67 1.67 0 0 1 2.384 0 1.882 1.882 0 0 1 0 2.535 1.669 1.669 0 0 1-1.192.503Z"
      fill="#fff"
    />
    <path
      d="m56.201 9.95-.07-.07.07.07Zm.644-1.636-.1-.002v.005l.1-.003ZM56.2 6.678l-.072.07.072-.07Zm-1.61-.67-.002.1h.004l-.001-.1Zm-1.608.67-.073-.069.073.069Zm0 3.272-.074.068.002.002.072-.07Zm.417-.369-.074.068.002.002.072-.07Zm0-2.535-.072-.07-.002.003.074.067Zm2.384 0 .074-.067-.002-.003-.072.07Zm0 2.535.072.07.002-.002-.074-.068Zm.346.298a2.167 2.167 0 0 1-1.538.643v.2c.63 0 1.235-.253 1.68-.702l-.142-.14Zm.615-1.562a2.12 2.12 0 0 1-.615 1.562l.142.141a2.32 2.32 0 0 0 .673-1.71l-.2.007Zm-.615-1.57c.406.417.628.98.615 1.565l.2.004a2.371 2.371 0 0 0-.672-1.708l-.144.14Zm-1.537-.64a2.086 2.086 0 0 1 1.536.64l.144-.138a2.286 2.286 0 0 0-1.683-.702l.003.2Zm-1.538.64a2.036 2.036 0 0 1 1.534-.64l.005-.2a2.235 2.235 0 0 0-1.684.702l.145.138Zm0 3.135a2.3 2.3 0 0 1 0-3.136l-.146-.136a2.5 2.5 0 0 0 0 3.408l.147-.136Zm1.537.64c-.577 0-1.13-.231-1.538-.643l-.143.141c.446.45 1.05.702 1.68.702v-.2Zm-1.264-.87c.334.34.789.532 1.264.532v-.2c-.421 0-.825-.17-1.121-.473l-.143.14Zm-.002-2.673a1.982 1.982 0 0 0 0 2.67l.147-.135a1.782 1.782 0 0 1 0-2.4l-.147-.135Zm1.266-.535c-.475 0-.93.192-1.264.532l.143.14c.296-.302.7-.472 1.12-.472v-.2Zm1.264.532a1.769 1.769 0 0 0-1.264-.532v.2c.421 0 .825.17 1.12.472l.144-.14Zm.002 2.673c.69-.755.69-1.916 0-2.67l-.148.135c.62.678.62 1.722 0 2.4l.148.135Zm-1.266.535c.475 0 .93-.192 1.264-.533l-.143-.14a1.57 1.57 0 0 1-1.121.473v.2Z"
      fill="#fff"
    />
    <path
      d="M57.642 10.524V6.103h.68l2.136 3.441V6.103h.564v4.421h-.585l-2.231-3.603V10.524h-.564Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.278 17.938v1.326h3.16a2.788 2.788 0 0 1-.732 1.673 3.22 3.22 0 0 1-2.443.973c-1.94 0-3.511-1.584-3.511-3.537 0-1.954 1.572-3.538 3.51-3.538a3.38 3.38 0 0 1 2.4.951l.93-.936a4.59 4.59 0 0 0-3.314-1.34 4.827 4.827 0 0 0-4.344 2.376 4.902 4.902 0 0 0 0 4.98 4.827 4.827 0 0 0 4.344 2.378 4.423 4.423 0 0 0 3.372-1.364 4.441 4.441 0 0 0 1.14-3.117 4.658 4.658 0 0 0-.065-.825h-4.447Zm8.104-.965c-1.72.004-3.112 1.412-3.108 3.146.004 1.734 1.402 3.136 3.123 3.132 1.721-.004 3.113-1.413 3.109-3.146a3.1 3.1 0 0 0-.903-2.234 3.053 3.053 0 0 0-2.22-.898Zm3.709 3.146c-.004-1.734 1.388-3.142 3.109-3.146a3.053 3.053 0 0 1 2.22.898 3.1 3.1 0 0 1 .903 2.234c.004 1.733-1.388 3.142-3.108 3.146-1.722.004-3.12-1.398-3.124-3.132Zm1.274.81a1.885 1.885 0 0 0 1.835 1.077c.485-.012.945-.22 1.276-.578a1.82 1.82 0 0 0 .48-1.323 1.901 1.901 0 0 0-1.2-1.766 1.878 1.878 0 0 0-2.07.475 1.912 1.912 0 0 0-.32 2.115Zm-6.817 0a1.885 1.885 0 0 0 1.834 1.077c.486-.012.946-.22 1.276-.578a1.82 1.82 0 0 0 .48-1.323 1.901 1.901 0 0 0-1.199-1.766 1.878 1.878 0 0 0-2.07.475 1.912 1.912 0 0 0-.321 2.115Zm24.21-3.956a2.929 2.929 0 0 1 2.663 1.997l.154.324-4.162 1.732c.26.6.858.977 1.507.95a1.76 1.76 0 0 0 1.529-.862l1.06.737a3.083 3.083 0 0 1-3.486 1.264 3.115 3.115 0 0 1-2.19-3.01 2.96 2.96 0 0 1 .79-2.205 2.916 2.916 0 0 1 2.136-.927Zm-1.58 3.043c-.03-.462.127-.917.434-1.263a1.707 1.707 0 0 1 1.198-.572c.482-.03.934.235 1.148.67l-2.78 1.165Zm-2.01 3.036h-1.369v-9.211h1.368v9.211Zm-3.607-5.38h-.051a2.144 2.144 0 0 0-1.639-.736 3.13 3.13 0 0 0-2.965 3.135 3.13 3.13 0 0 0 2.965 3.136 2.1 2.1 0 0 0 1.639-.737h.05v.45c0 1.2-.636 1.842-1.66 1.842a1.727 1.727 0 0 1-1.572-1.113l-1.185.494A2.926 2.926 0 0 0 58.9 26c1.602 0 2.926-.95 2.926-3.265v-5.578h-1.265v.516Zm-3.343 2.436c0 1.004.775 1.835 1.77 1.898a1.736 1.736 0 0 0 1.238-.591c.315-.36.47-.833.43-1.31a1.77 1.77 0 0 0-.435-1.304 1.743 1.743 0 0 0-1.233-.59 1.895 1.895 0 0 0-1.77 1.897Zm19.611-6.267h-3.277v9.211h1.368V19.56h1.91a2.84 2.84 0 0 0 2.633-1.367 2.885 2.885 0 0 0 0-2.984 2.84 2.84 0 0 0-2.634-1.367Zm-1.909 4.421h1.91l.029.015c.559 0 1.076-.3 1.355-.789.28-.488.28-1.089 0-1.577a1.563 1.563 0 0 0-1.355-.788H74.92v3.14Zm10.35-1.319a2.55 2.55 0 0 0-2.435 1.408l1.207.508a1.3 1.3 0 0 1 1.25-.67c.352-.042.704.06.98.284.274.223.449.548.484.902v.088a3.04 3.04 0 0 0-1.427-.353c-1.302 0-2.633.737-2.633 2.078.026.576.283 1.116.712 1.498.428.382.992.573 1.563.528a1.934 1.934 0 0 0 1.74-.899h.045v.737h1.317v-3.544c0-1.614-1.215-2.55-2.773-2.55l-.03-.015Zm-1.235 4.267c0 .552.621.781 1.068.781l.029.015a1.658 1.658 0 0 0 1.61-1.474 2.415 2.415 0 0 0-1.244-.31c-.688 0-1.463.25-1.463.988Zm8.836-4.053-1.565 3.994h-.044l-1.624-3.994h-1.463l2.436 5.586-1.39 3.102h1.426l3.746-8.688H92.87Zm-10.928 5.895h-1.361v-9.211h1.36v9.211Z"
      fill="#fff"
    />
    <path
      d="M10.103 6.501a1.474 1.474 0 0 0-.346 1.032v16.3c-.025.376.1.747.346 1.032l.052.059 9.13-9.13v-.222l-9.13-9.123-.052.052Z"
      fill="url(#a)"
    />
    <path
      d="m22.307 18.837-3.022-3.043v-.222l3.022-3.043.066.044 3.618 2.049c1.032.582 1.032 1.54 0 2.13L22.388 18.8l-.081.037Z"
      fill="url(#b)"
    />
    <path
      d="m22.395 18.793-3.11-3.11-9.182 9.182c.43.382 1.071.404 1.526.052l10.766-6.124Z"
      fill="url(#c)"
    />
    <path
      d="M22.395 12.573 11.63 6.457a1.186 1.186 0 0 0-1.526.044l9.182 9.182 3.11-3.11Z"
      fill="url(#d)"
    />
    <path
      opacity={0.2}
      d="m22.307 18.726-10.678 6.08c-.436.33-1.038.33-1.474 0l-.052.052.052.058c.436.33 1.038.33 1.474 0l10.766-6.123-.088-.067Z"
      fill="#fff"
    />
    <path
      opacity={0.12}
      d="M10.103 24.762a1.474 1.474 0 0 1-.324-1.04v.111c-.025.376.1.747.347 1.032l.051-.052-.074-.051ZM25.991 16.641l-3.684 2.085.066.067 3.618-2.049a1.29 1.29 0 0 0 .782-1.061 1.37 1.37 0 0 1-.782.958Z"
      fill="#fff"
    />
    <path
      opacity={0.25}
      d="m11.629 6.56 14.362 8.165c.398.177.688.533.781.958a1.29 1.29 0 0 0-.78-1.061L11.628 6.457c-1.024-.59-1.872-.103-1.872 1.076v.11c.022-1.179.848-1.665 1.872-1.083Z"
      fill="#fff"
    />
    <rect
      x={0.25}
      y={0.25}
      width={103.5}
      height={31.5}
      rx={3.75}
      stroke="#fff"
      strokeWidth={0.5}
    />
    <defs>
      <linearGradient
        id="a"
        x1={15.285}
        y1={-4.62}
        x2={0.664}
        y2={-0.729}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset={0.01} stopColor="#00A1FF" />
        <stop offset={0.26} stopColor="#00BEFF" />
        <stop offset={0.51} stopColor="#00D2FF" />
        <stop offset={0.76} stopColor="#00DFFF" />
        <stop offset={1} stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={27.34}
        y1={8.166}
        x2={9.514}
        y2={8.166}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset={0.41} stopColor="#FFBD00" />
        <stop offset={0.78} stopColor="orange" />
        <stop offset={1} stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={9.844}
        y1={10.907}
        x2={-1.919}
        y2={30.656}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset={1} stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={2.937}
        y1={3.965}
        x2={8.185}
        y2={12.784}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset={0.07} stopColor="#2DA771" />
        <stop offset={0.48} stopColor="#15CF74" />
        <stop offset={0.8} stopColor="#06E775" />
        <stop offset={1} stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

export { GooglePlayColored };
